import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const SubscriptionBroadcast = ()=>{
    const [subscriptionBroadcast, setSubscriptionBroadcast] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`subscriptionBroadcast?page=${page}`);
            setSubscriptionBroadcast(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`subscriptionBroadcast/${id}`);
            setSubscriptionBroadcast(subscriptionBroadcast.filter((subscriptionBroadcast) => subscriptionBroadcast.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'SubscriptionBroadcast'}>
            <InnerNav createLink={'/subscriptionBroadcastCreate'} listLink={'/subscriptionBroadcast'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Sent </th>
                                    <th className="px-4 py-3">Broadcasttime </th>
                                    <th className="px-4 py-3">Message </th>
                                    <th className="px-4 py-3">Service </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {subscriptionBroadcast.map((subscriptionBroadcast)=>{
                                         return(
                                             <tr key={subscriptionBroadcast.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{subscriptionBroadcast.id}</td>
                                                 <td className="px-4 py-3 text-sm">{subscriptionBroadcast.sent}</td>
                                                 <td className="px-4 py-3 text-sm">{subscriptionBroadcast.broadcasttime}</td>
                                                 <td className="px-4 py-3 text-sm">{subscriptionBroadcast.message}</td>
                                                 <td className="px-4 py-3 text-sm">{subscriptionBroadcast.service}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/subscriptionBroadcast/${subscriptionBroadcast.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(subscriptionBroadcast.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default SubscriptionBroadcast;